
import { Component, Prop, Emit, Vue } from 'vue-property-decorator'

@Component({})
export default class RightPanel extends Vue {
  name: string = 'RightPanel'

  @Prop({ type: Boolean, default: false }) show: boolean = false

  @Emit('close')
  doPanelClose() {}
}
